<template>
  <div class='tips'>
    <tinymce ref='tinymce' v-model='value' :height='500' />
    <el-button type='primary' style='margin-top: 12px' @click='save'>保存</el-button>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import { frontInf } from '@/api';

export default {
  name: 'Tips',
  components: {
    Tinymce
  },
  data() {
    return {
      value: ''
    };
  },
  mounted() {
    frontInf.getFrontContent({
      params: {
        module: 9
      }
    }).then(res => {
      if (res && res.data) {
        const { content } = res.data;
        if (typeof content === 'string') {
          this.value = content;
        }
      }
    });
  },
  methods: {
    save() {
      if (this.values !== '') {
        frontInf.setFrontContent({
          params: {
            module: 9,
            content: this.value
          }
        }).then(res => {
          if (res) {
            this.$message.success(res.msg || '保存成功！');
          }
        });
      }
    }
  }
};
</script>

<style scoped lang='less'>
.tips {
  padding: 12px;
}
</style>
